import * as widgetActions from "@app/widgets/widgets/statistics-aktiv-nps-widget/ngrx/statistics-aktiv-nps-widget.actions";
import {
  Action,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { WidgetsModuleState } from "@app/widgets/widgets-module.reducer";

export interface AktivNpsState {
  stats: any;
  loading: boolean;
}

export const initialState: AktivNpsState = {
  stats: null,
  loading: false,
};

export function aktivNpsReducer(state, action: Action): AktivNpsState {
  return reducer(state, action);
}

const reducer = createReducer(
  initialState,
  on(widgetActions.fetchStatisticsRequest, (state) => ({
    ...state,
    loading: true,
  })),
  on(widgetActions.fetchStatisticsSuccess, (state, { nps }) => ({
    ...state,
    loading: false,
    stats: nps,
  })),
  on(widgetActions.fetchStatisticsFail, (state) => ({
    ...state,
    loading: false,
  }))
);

const selectFeature = createFeatureSelector<WidgetsModuleState>("widgets");
const getState = createSelector(
  selectFeature,
  (state: WidgetsModuleState) => state.aktivNps
);
export const getStats = createSelector(
  getState,
  (state: AktivNpsState) => state.stats
);
export const getLoading = createSelector(
  getState,
  (state: AktivNpsState) => state.loading
);
